module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"zh-TW":{"title":"評價運營方式","review_permission":"評價撰寫權限","review_publication_period":"評價展示期限","rating_criteria_and_impact":"評價標準及影響","review_deletion_criteria_and_appeal_procedures":"評價刪除標準及異議處理程序"}}')
  delete Component.options._Ctor
}
